import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Paper, Alert } from '@mui/material';
import ScheduledClassForm from '../components/ScheduledClassForm';
import api, { handleApiError, translateValidationDetail } from '../utils/api';

const AddScheduledClassPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const duplicateData = location.state?.duplicateData;

  const handleSubmit = async (formData) => {
    try {
      console.log('Submitting scheduled class data:', formData);
      const response = await api.post('/scheduled-classes', formData);
      console.log('API Response:', response.data);

      if (response.data.success) {
        navigate('/admin/scheduled-classes', {
          state: {
            message: t('scheduledClass:messages.saveSuccess'),
            severity: 'success'
          }
        });
      }
    } catch (error) {
      console.error('Error creating scheduled class:', error);
      console.error('Validation details:', error.response?.data?.details);

      // Get translated error message
      const translatedError = handleApiError(error);

      // Log details if available
      const details = error.response?.data?.details;
      if (details && Array.isArray(details)) {
        details.forEach((detail, index) => {
          console.error(`Validation error ${index + 1}:`, detail);
        });

        // Translate detail messages using the helper function
        const translatedDetails = details.map(translateValidationDetail);

        const detailsText = translatedDetails.join(', ');
        throw new Error(`${translatedError}: ${detailsText}`);
      }

      throw new Error(translatedError);
    }
  };

  const handleCancel = () => {
    navigate('/admin/scheduled-classes');
  };

  return (
    <Box sx={{ maxWidth: 1000, mx: 'auto', p: 3 }}>
      <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          {duplicateData ? t('scheduledClass:addPage.duplicateTitle') : t('scheduledClass:addPage.title')}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {t('scheduledClass:addPage.description')}
        </Typography>
        
        <Alert severity="info" sx={{ mb: 3 }}>
          <strong>{t('scheduledClass:addPage.planAccessInfo')}</strong>
        </Alert>
      </Paper>

      <ScheduledClassForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        initialData={duplicateData}
      />
    </Box>
  );
};

export default AddScheduledClassPage;